<template>
  <div
    v-if="!is_active"
    class="tag tag--dark tooltip tag--large"
    data-tooltip="Inactive"
    >
    <i
      class="fa fa-wrapper fa-power-off"
      style="color: var(--cirrus-white);"
    >
    </i>
  </div>
</template>
<script>
export default {
  name: "inactive-icon",
  props: ["is_active"]
}
</script>
